<template>
  <div class="condition-select">
    <div v-if="conditionInfo.title" class="condition-select-title">
      {{ conditionInfo.title }}
    </div>
    <div class="condition-select-content">
      <span
        v-for="(tag, idx) in conditionInfo.conditionList"
        :key="idx"
        @click.stop="handleChangeCondition(tag)"
        :class="{
          actived: isActived(tag[keyProps.value]),
        }"
        class="filter-tag"
      >{{ tag[keyProps.label] }}
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import {
  IOptionProps,
  TModelValue,
  IConditionInfo,
  IReceiveConditionData,
} from './types';

export default defineComponent({
  name: 'ConditionSelect',
  components: {},
  props: {
    modelValue: {
      type: [String, Array] as PropType<TModelValue>,
      default: '',
    },
    conditionInfo: {
      type: Object as PropType<IConditionInfo>,
      required: true,
    },
    keyProps: {
      type: Object as PropType<IOptionProps>,
      default: () => ({
        value: 'value',
        label: 'label',
      }),
    },
    // 多选模式
    multiple: {
      type: Boolean,
      default: false,
    },
    // 互斥项（多选时，互斥项与其他项不会同时选中）
    incompat: {
      type: String,
    },
    // 可清除模式
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue', 'conditionChange'],
  setup(props, { emit }) {
    // 判断是否选中
    const isActived = (tagVal: string) => {
      const { modelValue } = props;
      // 多选数组情况
      if (Array.isArray(modelValue)) {
        return modelValue.includes(tagVal);
      }
      return modelValue === tagVal;
    };
    // 点击选项变化
    const handleChangeCondition = (tag: IReceiveConditionData) => {
      const {
        modelValue,
        keyProps,
        multiple,
        clearable,
        incompat,
        conditionInfo: { conditionList },
      } = props;
      const tagVal = tag[keyProps.value];
      // 单选
      if (!multiple) {
        // 可清除
        if (clearable) {
          // 当前modelValue和点击tag的value相等，要清空值
          if (modelValue === tagVal) {
            emit('update:modelValue', '');
            emit('conditionChange', '', null);
          }
          if (modelValue !== tagVal) {
            emit('update:modelValue', tagVal);
            emit('conditionChange', tagVal, tag);
          }
        }
        // 不可清除
        if (!clearable) {
          emit('update:modelValue', tagVal);
          emit('conditionChange', tagVal, tag);
        }
      }
      // 复选
      if (multiple) {
        if (Array.isArray(modelValue)) {
          const tarIndex = modelValue.findIndex(val => val === tagVal);
          if (tarIndex >= 0) {
            modelValue.splice(tarIndex, 1);
          }
          if (tarIndex === -1) {
            modelValue.push(tagVal);
          }
          // 互斥项 判断
          if (incompat !== undefined) {
            if (tagVal === incompat) {
              const len = modelValue.length;
              modelValue.splice(0, len, incompat);
            } else {
              const idx = modelValue.indexOf(incompat);
              if (idx > -1) {
                modelValue.splice(idx, 1);
              }
            }
          }
          const tarList = conditionList.filter(item => modelValue.includes(item[keyProps.value]));
          emit('conditionChange', modelValue, tarList, tagVal);
        }
      }
    };

    return {
      isActived,
      handleChangeCondition,
    };
  },
});
</script>

<style lang="scss">
.condition-select {
  display: flex;
  line-height: 26px;
  user-select: none;
  &-title {
    min-width: 72px;
    text-align: left;
    margin: 2px 5px 2px 0;
  }
  &-content {
    flex: 1;
  }
  .filter-tag {
    display: inline-block;
    opacity: 0.8;
    font-size: var(--el-font-size-extra-small);
    height: 26px;
    padding: 0 8px;
    border-radius: 3px;
    cursor: pointer;
    transform: all 2s;
    margin-right: 5px;
    margin-top: 2px;
    margin-bottom: 2px;
    &.actived {
      background: var(--el-color-primary);
      color: var(--el-color-white);
      opacity: 1;
    }
  }
}
</style>
